<template>
    <div>
        <Loading v-if="isLoading"/>
        <div class="container" v-else-if="asset !== null">
            <div class="row">
                <div class="col-12">
                    <ol class="breadcrumb">
                        <li><a :href="home_url"> HOME</a>
                        </li>
                        <li>
                            <router-link :to="{name: 'ArtifactsList'}">{{$t('archive')}}</router-link>
                        </li>
                        <li>{{ asset.title }}</li>
                    </ol>
                    <div class="content">
                        <div class="col-12">
                            <div class="jomon-archive-single">
                                <div class="collection-title">
                                    <h1>{{ asset.title }}</h1>
                                    <div class="tag-box">
                                        <ul class="tag-list" v-if="asset.artifact !== null">
                                            <template v-for="(site,index) in asset.artifact.sites" :key="site.id">
                                                <li><span class="site"
                                                          :class="site.area !== null ? getAreasBySite(site) : 'jomon-archaeological-sites'">{{site.title}}</span>
                                                </li>
                                                <li v-if="site.area !== null && asset.artifact.location !== null && index === (asset.artifact.sites.length - 1)"><span
                                                    class="r-icon"
                                                    :class="getAreasBySite(site)">{{asset.artifact.location}}</span>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                                <p v-if="asset.artifact !== null && typeof (asset.artifact) !== 'undefined'" class="artifact-label">
                                    {{$t('group')}}：{{ asset.artifact.title }}</p>
                                <div class="collection-display">
                                    <div class="display-image">
                                        <div class="youtube-container" v-if="asset.content_url !== null && asset.reference_type !== 'sannai-maruyama'">
                                            <youtube ref="youtube" width="100%" height="100%" :video-id="getId(asset.content_url)" @ready="onPlayerReady"></youtube>
                                        </div>
                                        <img v-else-if="typeof (asset.main_visual) !== 'undefined'"
                                             :src="asset.main_visual">
                                        <router-link class="prev"
                                                     v-if="this.prev !== null"
                                                     :to="{name: 'ArtifactDetail', params: {id: this.prev}}"><span
                                            class="material-icons">keyboard_arrow_left</span></router-link>
                                        <a v-else class="prev disable"><span
                                            class="material-icons">keyboard_arrow_left</span></a>
                                        <router-link class="next"
                                                     v-if="this.next !== null"
                                                     :to="{name: 'ArtifactDetail', params: {id: this.next}}"><span
                                            class="material-icons">keyboard_arrow_right</span></router-link>
                                        <a v-else class="next disable"><span
                                            class="material-icons">keyboard_arrow_right</span></a>
                                    </div>
                                    <div class="detail-box">
                                        <div class="detail" v-if="asset !== null">
                                            <dl>
                                                <dt>{{$t('asset_title_label')}}</dt>
                                                <dd>{{ asset.title !== null ? asset.title : '-' }}<span
                                                    v-if="lang == 'ja' && asset.title_reading !== null"> ({{ asset.title_reading
                                                    }})</span></dd>
                                                <dt>{{$t('description')}}</dt>
                                                <dd>{{ asset.description !== null ? asset.description : '-' }}</dd>
                                                <template v-if="asset.is_document">
                                                    <dt>{{$t('creation_organization')}}</dt>
                                                    <dd>{{ asset.creation_organization }} <span
                                                        v-if="asset.date_of_issue!== null"> ({{ formatDateJa(asset.date_of_issue)
                                                        }})</span></dd>
                                                    <dt>{{$t('jurisdiction_agency')}}</dt>
                                                    <dd>{{ asset.jurisdiction_agency }}</dd>
                                                    <dt>{{$t('content_rights_classification')}}</dt>
                                                </template>
                                                <template v-else>
                                                    <dt>{{$t('date_taken')}}</dt>
                                                    <dd>{{formatDateJa(asset.image_date)}} <span
                                                        v-if="asset.photographer!== null"> ({{ asset.photographer
                                                        }})</span></dd>
                                                    <dt>{{$t('supervisory_organization')}}</dt>
                                                    <dd>{{ asset.jurisdiction_agency !== null ? asset.jurisdiction_agency : '-' }}</dd>
                                                    <dt>{{$t('licenses')}}</dt>
                                                </template>
                                                <dd>
                                                    <template
                                                        v-if="typeof (asset.license) !== 'undefined' && asset.license !== null">
                                                        <a
                                                            :href="getLicenseUrl(asset.license.slug)"
                                                            target="blank">
                                                            <img :src="asset.license.image"
                                                                 alt="{{asset.license.name}}">
                                                        </a>
                                                    </template>
                                                    <template v-else>-</template>
                                                </dd>
                                            </dl>
                                        </div>
                                        <div v-if="asset.reference_type == 'sannai-maruyama' && asset.reference_url !== null" class="new-window-button">
                                            <a :href="asset.reference_url" target="_blank">
                                                <div>
                                            <span class="material-icons">
                                                open_in_new
                                             </span>
                                                    外部サイトへ移動
                                                </div>
                                            </a>
                                        </div>
                                        <div v-else class="dl-list-button">
                                            <div class="open-button">
                                                <a :href="asset.normalized" target="_blank"
                                                   v-if="asset.type !== null && asset.type.rootAncestor !== null && asset.type.rootAncestor.slug === 'files'">
                                                    <div>
                                                    <span class="material-icons">
                                                    auto_stories
                                                    </span>{{$t('open_the_file')}}
                                                    </div>
                                                </a>
                                                <a href="javascript:;" v-else-if="asset.type !== null && ((asset.type.slug === 'file' || asset.type.slug === 'image'))" @click="addRemoveFromCart">
                                                    <div><span class="material-icons">save_alt</span>
                                                        <span
                                                            id="asset_text">{{isInCart ? $t('remove_from_download_list') : $t('add_to_download_list')}}</span>
                                                    </div>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="ather-collections" v-if="relation_assets.length >0">
                                    <ul class="item-list">
                                        <li v-for="relation_asset in relation_assets" :key="relation_asset.id"
                                            :class=" relation_asset.id == id ? 'active' : ''">
                                            <router-link
                                                :to="{name: 'ArtifactDetail', params: {id: relation_asset.id}}">
                                                <img :src="relation_asset.thumbnail"
                                                     alt="" width="180" height="180">
                                                <dl>
                                                    <dt>{{ relation_asset.title }}</dt>
                                                    <dd>{{$t('date')}}：{{ formatDateJa(relation_asset.image_date) }}
                                                    </dd>
                                                    <dd v-if="relation_asset.holding_organization !== null">
                                                        {{$t('holding_organization')}}：{{ relation_asset.holding_organization}}
                                                    </dd>
                                                </dl>
                                            </router-link>
                                        </li>
                                    </ul>
                                    <div class="back-to-search">
                                        <router-link :to="{name: 'ArtifactsList'}">{{$t('return_to_the_archives')}}
                                        </router-link>
                                    </div>
                                </div>
                                <section v-if="asset.artifact !== null && typeof (asset.artifact.sites) !== 'undefined'">
                                    <h2><span>{{$t('learn_about_the_jomon')}}</span></h2>
                                    <div class="more-learn" v-for="site in asset.artifact.sites" :key="site.id">
                                        <a :href="home_url + '/learn/jomon-sites/' + site.slug">
                                            <img :src="site.image" alt="">
                                            <p>{{site.title}}</p>
                                        </a>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AssetCart :total="total"/>
    </div>
</template>

<script>
import Loading from "../components/Loading";
import AssetCart from "../components/AssetCart";
import axios from "axios";

export default {
    name: "AssetDetail",
    components: {AssetCart, Loading},
    mounted() {
        window.history.scrollRestoration = "manual"
        window.scrollTo(0, 0)
    },
    computed: {
        player() {
            return this.$refs.youtube.player
        }
    },
    data() {
        return {
            isLoading: false,
            asset: null,
            lang: lang,
            relation_assets: [],
            home_url: home_url,
            id: this.$route.params.id,
            isInCart: false,
            total: 0,
            next: null,
            prev: null
        }
    },
    created() {
        this.getAsset()
        this.getRelationAsset()
        this.checkItemInCart()
        this.getTotal()
    },
    methods: {
        getId (url) {
            return this.$youtube.getIdFromUrl(url)
        },
        getLicenseUrl(license) {
            switch (license) {
                case 'cc-by':
                    return 'https://creativecommons.org/licenses/by/4.0/deed.ja'
                case 'cc-by-nc':
                    return 'https://creativecommons.org/licenses/by-nc/4.0/deed.ja'
                case 'cc-by-nc-nd':
                    return 'https://creativecommons.org/licenses/by-nc-nd/4.0/deed.ja'
                case 'cc-by-nc-sa':
                    return 'https://creativecommons.org/licenses/by-nc-sa/4.0/deed.ja'
                case 'cc-by-nd':
                    return 'https://creativecommons.org/licenses/by-nd/4.0/deed.ja'
                case 'cc-by-sa':
                    return 'https://creativecommons.org/licenses/by-sa/4.0/deed.ja'
                case 'cc0':
                    return 'https://creativecommons.org/publicdomain/zero/1.0/deed.ja'
                default:
                    return 'https://rightsstatements.org/page/InC/1.0/'
            }
        },
        formatDateJa(asset_date) {
            if (asset_date === null) return '-'
            if (this.lang === 'ja') {
                return asset_date
            } else {
                asset_date = asset_date.replace('年', '/')
                asset_date = asset_date.replace('月', '/')
                asset_date = asset_date.replace('日', '')
                return asset_date
            }
        },
        getAreasBySite(site) {
            if (site.area.parent !== null) {
                return site.area.parent_slug;
            } else {
                return site.area.slug
            }
        },
        getTotal() {
            let cart = localStorage.getItem('cart')
            if (cart) {
                let temp = cart.split(',')
                this.total = temp.length
            } else {
                this.total = 0
            }
        },
        checkItemInCart() {
            let cart = localStorage.getItem('cart')
            if (cart) {
                let temp = cart.split(',')
                this.isInCart = temp.includes(this.$route.params.id) || temp.includes(this.$route.params.id.toString())
            } else {
                this.isInCart = false
            }
        },
        addRemoveFromCart() {
            let asset_id = this.$route.params.id.toString()
            let cart = localStorage.getItem('cart')
            if (cart) {
                let temp = cart.split(',')
                if (temp.includes(asset_id)) {
                    let index = temp.indexOf(asset_id)
                    if (index > -1) {
                        temp.splice(index, 1);
                    }
                } else {
                    if (temp.length > 30) {
                        alert('You can download up to 30 files per download.')
                    } else {
                        temp.push(asset_id)
                    }
                }
                this.total = temp.length
                localStorage.setItem('cart', temp.join(','))
            } else {
                let temp = []
                temp.push(asset_id)
                localStorage.setItem('cart', temp.join(','))
                this.total = 1
            }
            this.isInCart = !this.isInCart
        },
        onPlayerReady() {
            this.player.playVideo()
        },
        getAsset() {
            this.isLoading = true
            const config = {
                params: {
                    lang: this.lang
                }
            }
            axios.get('/api/assets/detail/' + this.id, config)
                .then((res) => {
                    this.asset = res.data.data
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        getRelationAsset() {
            this.isLoading = true
            const config = {
                params: {
                    lang: this.lang
                }
            }
            axios.get('/api/assets/related/' + this.id, config)
                .then((res) => {
                    this.relation_assets = res.data
                    if(this.relation_assets.length > 0){
                        let ids = this.relation_assets.map(item => {
                            return item.id
                        })
                        let currentIndex = ids.indexOf(parseInt(this.id))
                        if(currentIndex > 0){
                            this.prev = ids[currentIndex - 1]
                        }
                        if(currentIndex < (ids.length-1)){
                            this.next = ids[currentIndex + 1]
                        }
                    }
                })
                .finally(() => {
                    this.isLoading = false
                })
        }
    }
}
</script>

<style scoped>

</style>
